import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { curry, map } from 'ramda';
import PropTypes from 'prop-types';
var withPageMetaData = curry(function (_ref, Component, props) {
  var _ref$meta = _ref.meta,
    meta = _ref$meta === undefined ? [] : _ref$meta,
    title = _ref.title;
  return React.createElement(Fragment, null, React.createElement(Helmet, null, title && React.createElement('title', null, title), map(function (_ref2) {
    var key = _ref2[0],
      value = _ref2[1];
    return React.createElement('meta', {
      name: key,
      content: value,
      key: key
    });
  }, meta)), React.createElement(Component, props));
});
withPageMetaData.displayName = 'WithPageMetadata';
withPageMetaData.propTypes = {
  options: PropTypes.shape({
    title: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.array)
  }),
  Component: PropTypes.element
};
export var withPageMetadata = withPageMetaData;
export var metadata = function metadata(title) {
  return {
    title: title + ' | PGA.org',
    meta: [['description', 'PGA.org']]
  };
};